export interface QuickBooksExportablePurchaseOrderConstructor {
  procurifyPoNumber: number // procurify_PO — selection key for stage/archive/unstage
  poNumber: string // PO_Num; may be empty
  date: ISODateString
  purchaserName: string
  vendorName: string
  total: string
  uuid: string // detail link /#/purchase/order/details/{uuid}
  stagedForExport: boolean
}

export class QuickBooksExportablePurchaseOrder {
  readonly procurifyPoNumber: number
  readonly poNumber: string
  readonly date: Date
  readonly purchaserName: string
  readonly vendorName: string
  readonly total: string
  readonly uuid: string
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportablePurchaseOrderConstructor) {
    this.procurifyPoNumber = data.procurifyPoNumber
    this.poNumber = data.poNumber
    this.date = new Date(data.date)
    this.purchaserName = data.purchaserName
    this.vendorName = data.vendorName
    this.total = data.total
    this.uuid = data.uuid
    this.stagedForExport = data.stagedForExport
  }

  // PO label on every tab: PO_Num when present, else "PF{procurify_PO}"
  // (BHV-034).
  get displayLabel(): string {
    return this.poNumber || `PF${this.procurifyPoNumber}`
  }
}
